import React from 'react';
import { FaGithub, FaLinkedin, FaDev, FaEnvelope, FaGraduationCap } from 'react-icons/fa';
import me from '../assets/me2.jpeg';
import "./About.css";
import NumberCard from './NumberCard';
// import SkillsGrid from './SkillsGrid';
import EmploymentList from './EmploymentList';
import TickerBar from './TickerBar';

function About() {
  return (
    <div className="master-container">
      <div className="header">
        <h3>About</h3>
        <h1>Howard Huang</h1>
      </div>
      <div className="divided-container">
        <div className="picture">
          <img src={me} alt="" />
        </div>
        <div className="content">
          <p>
            I am a grad student at Harvard studying Computer Science and Applied Math. 
            Previously, I completed my undergrad at UCLA. 
            Broadly, my academic interests center around longevity, drug discovery, reinforcement learning, legged robotics, LLMs, and artificial intelligence.
            In the past, I worked on research both at MIT and NVIDIA, and have created apps with 30M+ users. 
          </p>
          <div className="links-container">
            <div className="links">
              <ul>
                <li><FaGithub className="icon" /> <strong>Github:</strong> <span><a href="https://github.com/HowardHuang1" target="_blank" rel="noopener noreferrer">HowardHuang1</a></span></li>
                <li><FaLinkedin className="icon" /> <strong>LinkedIn:</strong> <span><a href="https://www.linkedin.com/in/howardhuangz/" target="_blank" rel="noopener noreferrer">LinkedIn</a></span></li>
                <li><FaEnvelope className="icon" /> <strong>Email:</strong> <span>howardhuangb@gmail.com</span></li>
              </ul>
            </div>
            <div className="links">
              <ul>
                <li><FaGraduationCap className="icon" /> <strong>Google Scholar:</strong> <span><a href="https://scholar.google.com/citations?user=0yLsC9gAAAAJ&hl=en" target="_blank" rel="noopener noreferrer">Scholar</a></span></li>
                <li><FaDev className="icon" /> <strong>Devpost:</strong> <span><a href="https://devpost.com/howardhuang2004" target="_blank" rel="noopener noreferrer">howardhuang2004</a></span></li>
                <li><FaDev className="icon" /> <strong>Devfolio:</strong> <span><a href="https://devfolio.co/@Howard" target="_blank" rel="noopener noreferrer">https://devfolio.co/@Howard</a></span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="statsbar">
        <NumberCard title="App Downloads" number={34000000} />
        <NumberCard title="Projects" number={24} />
        <NumberCard title="Dollars Raised" number={13000} />
        <NumberCard title="Awards" number={18} />
      </div>
      <div className="employment-section">
        <EmploymentList />
      </div>
      <div className="skills-section">
        <TickerBar />
      </div>
    </div>
  );
}

export default About;
